import { combineReducers } from 'redux';

/**
 * maco-magsael-sc-551: Accounting - Create Invoice generator
 * new-shipyard
 * maco-magsael-sc-663: Shipyard - add files and pinpoint feature
 * olain-tarcina-sc-664: Hours of Rest - print revamp
 * maco-magsael-sc-677: YMP Lite - Interface for lite equipment and jobs
 * maco-magsael-sc-689: Charter - create charter interface
 * maco-magsael-sc-691: Sales - Create TYS Sales module
 * maco-magsael-sc-692: Payroll - Create payroll module
 * maco-magsael-sc-754: Shipyard - create interface to manage shipyard projects
 * maco-magsael-sc-913: Product - Product feature creation
 * maco-magsael-sc-939: Sales - Modification v4
 * maco-magsael-sc-984: YMP Online - Accounting - Source of Payment Collection
 * maco-magsael-sc-1000: Logbook - add mooring log in list of logbooks
 * aldrine-facistol-sc-1165: Logbook - Add dropdown for 2 fields
 *
 */

import auth from './auth';
import alert from './alert';
import theme from './theme';
import worklist from './worklist';
import group from './group';
import doc from './doc';
import history from './history';
import logbook from './logbook';
import subgroup from './subgroup';
import inventory from './inventory';
import profile from './profile';
import user from './user';
import guests from './guests';
import photo from './photo';
import boat from './boat';
import ympequipment from './ympequipment';
import ympjob from './ympjob';
import form from './form';
import subform from './subform';
import boatform from './boatform';
import location from './location';
import sparejob from './sparejob';
import taskgroup from './taskgroup';
import event from './event';
import watchkeeper from './watchkeeper';
import watchkeeplog from './watchkeeplog';
import hourevent from './hourevent';
import vacation from './vacation';
import boatsubform from './boatsubform';
import formarchive from './formarchive';
// modification start - 08.31.2022 - ympshipyard
import team from './team';
import discussion from './discussion';
import project from './project';
import deck from './deck';
import room from './room';
import projecthistory from './projecthistory';
// modification end - 08.31.2022 - ympshipyard
// modificationm start - 09.28.2022 - ymploki-197
import spare from './spare';
import equipment from './equipment';
import sectionlist from './sectionlist';
import orderlist from './orderlist';
import supplier from './supplier';
// modification end - 09.28.2022 - ymploki-197
// modificationm start - 10.31.2022 - ymploki-277
import log from './log';
import logrecord from './logrecord';
// modificationm end - 10.31.2022 - ymploki-277
// modificationm start - 12.16.2022 - ymploki-277
import expense from './expense';
import merchant from './merchant';
import category from './category';
// modificationm end - 12.16.2022 - ymploki-277
// modification start - 02.06.2023 - great-galing-sc-325
import subcategory from './subcategory';
// modification end - 02.06.2023 - great-galing-sc-325
/** Modifications
 * great-galing-sc-325: Add department to all fields
 */
// Modification start - 03.07.2023 - olain-tarcina-sc-451
import sales from './sales';
import yacht from './yacht';
// Modification end - 12.07.2023 - olain-tarcina-sc-451
// modification start - 08.04.2023 - maco-magsael-sc-458
import calendar from './calendar';
// modification end - 08.04.2023 - maco-magsael-sc-458
// Modification start - 07.30.2023 - management-module
import management from './management';
// Modification end - 07.30.2023 - management-module
import yachtmake from './yachtmake';
// Modification start - Position field
import position from './position';
// Modification end - Position field
// Modification start - Business field
import business from './business';
// Modification end - Business field
// Modification start - 09.20.2023 - maco-magsael-sc-485
import part from './part';
// Modification end - 09.20.2023 - maco-magsael-sc-485
// modification start - 12.07.2023 - maco-magsael-sc-551
import invoice from './invoice';
// modification end - 12.07.2023 - maco-magsael-sc-551
// Modification start - 25.09.2023 - olain-tarcina-sc-479
import notification from './notification';
// Modification end - 25.09.2023 - olain-tarcina-sc-479
// Modification start - 04.24.2024 - new-shipyard
import shipyard from './shipyard';
import shipyardhistory from './shipyardhistory';
import shipyarddoc from './shipyarddoc';
// Modification end - 04.24.2024 - new-shipyard
// Modification start - 07.18.2024 - nmaco-magsael-sc-663
import plan from './plan';
// Modification end - 07.18.2024 - nmaco-magsael-sc-663
// Modification start - 19.08.2024 - olain-tarcina-sc-664
import timesheet from './timesheet';
// Modification end - 19.08.2024 - olain-tarcina-sc-664
// Modification start - 08.22.2024 - nmaco-magsael-sc-677
import liteympequipment from './liteympequipment';
import liteympjob from './liteympjob';
import liteympboat from './liteympboat';
import litegroup from './litegroup';
import liteworklist from './liteworklist';
// Modification end - 08.22.2024 - nmaco-magsael-sc-677
// Modification start - 09.22.2024 - maco-magsael-sc-689
import charter from './charter';
import allowance from './allowance';
import contract from './contract';
// Modification end - 09.22.2024 - maco-magsael-sc-689
// Modification start - 09.26.2024 - maco-magsael-sc-691
import tyssales from './tyssales';
// Modification end - 09.26.2024 - maco-magsael-sc-691
// modification start - 10.07.2024 - maco-magsael-sc-692
import payroll from './payroll';
// modification end - 10.07.2024 - maco-magsael-sc-692
// modification start - 03.07.2025 - maco-magsael-sc-754
import program from './program';
// modification end - 03.07.2025 - maco-magsael-sc-754
//804-maco
import imologhistory from './imologhistory';
//804-maco
// modification start - 01.29.2026 - maco-magsael-sc-913
import product from './product';
// modification end - 01.29.2026 - maco-magsael-sc-913
// modification start - 06.03.2026 - maco-magsael-sc-984
import sourceofpayment from './sourceofpayment';
// modification end - 06.03.2026 - maco-magsael-sc-984
import medicalinventory from './medicalinventory';
// MooringLines reducer
import mooringline from './mooringline';
import mooringlinehistory from './mooringlinehistory';
// Modification start - 09.30.2026 - aldrine-facistol-sc-1165
import mooringlocation from './mooringlocation';
import mooringlineused from './mooringlineused';
// Modification end - 09.30.2026 - aldrine-facistol-sc-1165

const reducers = combineReducers({
  auth,
  theme,
  alert,
  worklist,
  group,
  doc,
  history,
  logbook,
  subgroup,
  inventory,
  profile,
  user,
  guests,
  photo,
  boat,
  ympequipment,
  ympjob,
  form,
  subform,
  boatform,
  location,
  sparejob,
  taskgroup,
  event,
  watchkeeper,
  watchkeeplog,
  hourevent,
  vacation,
  boatsubform,
  formarchive,
  // modification start - 08.31.2022 - ympshipyard
  team,
  discussion,
  project,
  deck,
  room,
  projecthistory,
  // modification end - 08.31.2022 - ympshipyard
  // modificationm start - 09.28.2022 - ymploki-197
  spare,
  equipment,
  sectionlist,
  orderlist,
  supplier,
  // modification end - 09.28.2022 - ymploki-197
  // modificationm start - 10.31.2022 - ymploki-277
  log,
  logrecord,
  // modificationm end - 10.31.2022 - ymploki-277
  // modificationm start - 12.16.2022 - ymploki-277
  expense,
  merchant,
  category,
  // modificationm end - 12.16.2022 - ymploki-277
  // modification start - 02.06.2023 - great-galing-sc-325
  subcategory,
  // modification end - 02.06.2023 - great-galing-sc-325
  sales,
  yacht,
  // modification start - 08.04.2023 - maco-magsael-sc-458
  calendar,
  // modification end - 08.04.2023 - maco-magsael-sc-458
  // Modification start - 07.30.2023 - management-module
  management,
  // Modification end - 07.30.2023 - management-module
  yachtmake,
  // Modification start - Position field
  position,
  // Modification end - Position field
  // Modification start - Business field
  business,
  // Modification end - Business field
  // Modification start - 09.20.2023 - maco-magsael-sc-485
  part,
  // Modification end - 09.20.2023 - maco-magsael-sc-485
  // modification start - 12.07.2023 - maco-magsael-sc-551
  invoice,
  // modification end - 12.07.2023 - maco-magsael-sc-551
  // Modification start - 25.09.2023 - olain-tarcina-sc-479
  notification,
  // Modification end - 25.09.2023 - olain-tarcina-sc-479
  // Modification start - 04.24.2024 - new-shipyard
  shipyard,
  shipyardhistory,
  shipyarddoc,
  // Modification end - 04.24.2024 - new-shipyard
  // Modification start - 07.18.2024 - nmaco-magsael-sc-663
  plan,
  // Modification end - 07.18.2024 - nmaco-magsael-sc-663
  // Modification start - 19.08.2024 - olain-tarcina-sc-664
  timesheet,
  // Modification end - 19.08.2024 - olain-tarcina-sc-664
  // Modification start - 08.22.2024 - nmaco-magsael-sc-677
  liteympequipment,
  liteympjob,
  liteympboat,
  litegroup,
  liteworklist,
  // Modification end - 08.22.2024 - nmaco-magsael-sc-677
  // Modification start - 09.22.2024 - maco-magsael-sc-689
  charter,
  allowance,
  contract,
  // Modification end - 09.22.2024 - maco-magsael-sc-689
  // Modification start - 09.26.2024 - maco-magsael-sc-691
  tyssales,
  // Modification end - 09.26.2024 - maco-magsael-sc-691
  // modification start - 10.07.2024 - maco-magsael-sc-692
  payroll,
  // modification end - 10.07.2024 - maco-magsael-sc-692
  // modification start - 03.07.2025 - maco-magsael-sc-754
  program,
  // modification end - 03.07.2025 - maco-magsael-sc-754
  //804-maco
  imologhistory,
  //804-maco
  // modification start - 01.29.2026 - maco-magsael-sc-913
  product,
  // modification end - 01.29.2026 - maco-magsael-sc-913
  // modification start - 06.03.2026 - maco-magsael-sc-984
  sourceofpayment,
  // modification end - 06.03.2026 - maco-magsael-sc-984
  medicalinventory,
  // MooringLines history reducer
  mooringlinehistory,
  // MooringLines reducer
  mooringline,
  // Modification start - 09.30.2026 - aldrine-facistol-sc-1165
  mooringlocation,
  mooringlineused,
  // Modification end - 09.30.2026 - aldrine-facistol-sc-1165
});

export default reducers;
